import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "custom-lists-empty__links" }

import EmptyListingBlock from '@/app/components/listing/EmptyListingBlock.vue'
import AppButton from '@/app/components/button/AppButton.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'CustomListEmpty',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(EmptyListingBlock, {
    class: "custom-lists-empty",
    useDefaultImage: true
  }, {
    default: _withCtx(() => [
      _cache[2] || (_cache[2] = _createElementVNode("p", { class: "custom-lists-empty__text" }, [
        _createTextVNode(" Books you add to this list will appear here. To add a book, click on the "),
        _createElementVNode("span", { class: "iconfont iflag2" }),
        _createTextVNode(" icon on the book card, then on \"Add to List\" and select one of the lists. ")
      ], -1)),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(AppButton, {
          outlined: true,
          class: "custom-lists-empty__btn custom-lists-empty__btn--books",
          tag: "router-link",
          to: { name: 'books' }
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("Go to Books", -1)
          ]))]),
          _: 1
        }),
        _createVNode(AppButton, {
          class: "custom-lists-empty__btn custom-lists-empty__btn--search",
          tag: "router-link",
          to: { name: 'search' }
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode("Go to Search", -1)
          ]))]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})